import request from '@/config/axios'

/** 吉凶档位选项（与后端 DailySignConstants 1-5 对齐） */
export const DAILY_SIGN_LEVEL_OPTIONS: { label: string; value: number }[] = [
  { label: '上上', value: 5 },
  { label: '上吉', value: 4 },
  { label: '中吉', value: 3 },
  { label: '中平', value: 2 },
  { label: '下下', value: 1 }
]

/** 档位标签映射（表格 tag 用） */
export const DAILY_SIGN_LEVEL_LABELS: Record<number, string> = {
  5: '上上',
  4: '上吉',
  3: '中吉',
  2: '中平',
  1: '下下'
}

/** 档位 tag 类型映射（el-tag 颜色） */
export const DAILY_SIGN_LEVEL_TAG_TYPES: Record<number, string> = {
  5: 'warning',
  4: 'success',
  3: 'primary',
  2: 'info',
  1: 'danger'
}

/** 签库 VO */
export interface DailySignPoolVo {
  id?: number
  signNo: number
  title: string
  titleMeaning?: string
  poem: string
  level: number
  interpret?: string
  yi?: string
  ji?: string
  sort?: number
  status?: number
  createTime?: Date
}

/** 签库分页查询参数 */
export interface DailySignPoolPageParams {
  pageNo?: number
  pageSize?: number
  title?: string
  level?: number
  status?: number
}

/** 抽签记录 VO */
export interface DailySignRecordVo {
  id: number
  memberId: number
  memberNickname?: string
  mobile?: string
  signDate: string
  signNo?: number
  title?: string
  level?: number
  createTime?: Date
}

/** 抽签记录分页查询参数 */
export interface DailySignRecordPageParams {
  pageNo?: number
  pageSize?: number
  memberId?: number
  nickname?: string
  mobile?: string
  signDate?: string[]
}

export const DailySignPoolApi = {
  // 查询签库分页（签号升序）
  getPoolPage: (params: DailySignPoolPageParams) => {
    return request.get({ url: '/xuanxue/daily-sign-pool/page', params })
  },
  // 查询签文详情（编辑回显）
  getPool: (id: number) => {
    return request.get({ url: '/xuanxue/daily-sign-pool/get?id=' + id })
  },
  // 新增签文（签号唯一校验）
  createPool: (data: DailySignPoolVo) => {
    return request.post({ url: '/xuanxue/daily-sign-pool/create', data })
  },
  // 修改签文
  updatePool: (data: DailySignPoolVo) => {
    return request.put({ url: '/xuanxue/daily-sign-pool/update', data })
  },
  // 修改签文状态（启用/停用，停用不参与抽取）
  updatePoolStatus: (id: number, status: number) => {
    return request.put({ url: '/xuanxue/daily-sign-pool/update-status', params: { id, status } })
  },
  // 删除签文（物理删除）
  deletePool: (id: number) => {
    return request.delete({ url: '/xuanxue/daily-sign-pool/delete?id=' + id })
  }
}

export const DailySignRecordApi = {
  // 查询抽签记录分页（昵称模糊/手机号精确/签日期范围）
  getRecordPage: (params: DailySignRecordPageParams) => {
    return request.get({ url: '/xuanxue/daily-sign-record/page', params })
  }
}
